<template>
  <Page :response="response">
    <VoucherTemplateForm :voucher-template="resource"
                         :setup-complete="setupComplete"
                         :merchant="merchant"
                         :currency-tenants="currencyTenants"
                         :countries="countries"
                         :sequence-numbers="sequenceNumbers"
                         @formSubmit="updateFormSubmitted($event, { companyId: merchant.id })" />
  </Page>
</template>

<script>
import store from "./VoucherTemplateStore";
import SequenceNumberStore from "./SequenceNumberStore";
import SetupStore from "@shared/components/Setup/SetupStore";
import CompanyStore from "@shared/components/Company/CompanyStore";
import TenantStore from "@tenant_admin/stores/TenantStore";
import CountryStore from "../../../dashboard/stores/CountryStore";
import VoucherTemplateForm from "./VoucherTemplateForm.vue";
import VoucherTemplateMixin from "./VoucherTemplateMixin";

const responseStore = {
  response: {
    resource: {}
  }
};

const fetchResource = async (to, from, next) => {
  responseStore.response = await store.fetch(to.params.id,
    { companyId: CompanyStore.currentCompany.id });

  responseStore.sequenceNumbers = await SequenceNumberStore.fetchAll(
    { companyId: CompanyStore.currentCompany.id });
  responseStore.currencyTenants = await TenantStore.methods.fetchVisibleCurrencyTenants(
    Dashboard.currentTenant.id,
    CompanyStore.currentCompany.country.id
  );
  responseStore.countries = await CountryStore.collection("public");

  next();
};

export default {
  name: "VoucherTemplateEdit",

  title () {
    return `Edit Template - ${Dashboard.currentTenant.name}`;
  },

  components: {
    VoucherTemplateForm
  },

  mixins: [VoucherTemplateMixin],

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  data: function () {
    return {
      store: store,
      setupStoreState: SetupStore.state,
      responseStore: responseStore
    };
  },

  computed: {
    setupComplete () {
      return this.setupStoreState.stage === 4;
    },

    merchant () {
      return CompanyStore.state.company;
    },

    sequenceNumbers () {
      return this.responseStore.sequenceNumbers.collection;
    },

    currencyTenants () {
      return this.responseStore.currencyTenants;
    },

    countries () {
      return responseStore.countries;
    }
  },

  mounted () {
    this.addBreadcrumb("Edit Template");
  }
};
</script>
